import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 9: Miracle on the Han River and the New Korea</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 9: 한강의 기적</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">


{/* INTRO */}
전쟁 (jeon jaeng) — war <br></br>
후 (who) — after <br></br>
나라 (nah ra) — country <br></br>
난리 (nan ri) — chaos <br></br>
성장하다 (sung jang) — to grow <br></br>
6.25 전쟁 (yook eeh o jeon jang) — Korean war <br></br>
<br></br>Pictures of the Korean War (6.25 전쟁):<br></br>
<img className="epPic-m" src="https://images.chosun.com/resizer/KJC_QIGDa6k63Csk6tZXUYVq6kU=/1080x844/smart/cloudfront-ap-northeast-1.images.arcpublishing.com/chosun/GBQKRW3ZNBTQXOYFJHAEWAJPX4.jpg"></img><br></br>
<img className="epPic-m" src="http://img.segye.com/content/image/2020/06/25/20200625519770.JPG"></img><br></br>
<img className="epPic-m" src="https://www.wikileaks-kr.org/news/photo/202106/109905_91165_2844.jpg"></img><br></br>
<br></br>

<br></br>
{/* DICTATORSHIP */}
김구 (kim gu) — political opponent of President Lee Seung Man (이승만) who was assassinated (pictured below)<br></br>
<img className="epPic-m" src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Kim_Gu_in_1949.jpg/250px-Kim_Gu_in_1949.jpg"></img><br></br>
<br></br>
민간인 (min gan in) — civilian <br></br>
공산주의자 (gong san ju wi ja) — communist <br></br>
의심 (wi sim) — suspicion <br></br>
죽였습니다 (juk yut seup ni da) — killed <br></br>

많은 사람들 (man eun sah ram deul) — many people <br></br>
싫어해요 (sil uh hae yo) — dislike <br></br>
선거 (sun guh) — election <br></br>
개표조작 (gae pyo jo jak) — voting manipulation <br></br>

<br></br>
{/* PROTEST */}
학생 (hak saeng) — students <br></br>
시위 (si wee) — protest <br></br>
시민들 (shi min deul) — civilians <br></br>
시위 (si wee) — protest <br></br>
참여하다 (cham yuh ha da) — to participate in <br></br>
혁명 (hyuk myung) — revolution <br></br>
사퇴하다 (sah twae ha da) — to resign <br></br>

<br></br>
{/* ECONOMY */}
자유민주주의 (jah yoo min joo joo eeh) — liberal democracy <br></br>
기반으로 (gi ban euh ro) — based on <br></br>
5개년 경제개발계획 — Five Year Plans that were designed to improve the economy of South Korea <br></br>
임시 군정 (im si goon jung) — temporary military government was created <br></br>
대한민국 제3공화국 (dae han min guk jae sam hwa guk) — the Third Republic <br></br>
경제 (gyung jae) — economy <br></br>
개발 (gae bal) — development <br></br>
5개년 (oh gae nyeon) — 5 years <br></br>
계획 (gae hwik) — plan <br></br>
경제적 (gyung jae juk) — economically <br></br>
빠르게 (ppae ruh gae) — rapidly <br></br>
성장하다 (sung jang ha da) — to grow <br></br>
도로 (do ro) — road <br></br>
항만 (hang man) — harbor <br></br>
공항 (gong hang) — airport <br></br>
식량 생산 (sik ryang saeng san) — food production <br></br>
한강 (hang gang) — Han River in Korea <br></br>
기적 (gi juk) — miracle <br></br>
대단하다 (dae dan ha da) — to be amazing <br></br>
개헌 (gae hun) — Constitution <br></br>
바꾸다 (ba ggu da) — to change <br></br>
정치 활동 (jung chi hwal dong) — political activity <br></br>
언론 (un ron) — journalism/press <br></br>
표현 (pyo hyun) — speech/expression <br></br>

<br></br>
{/* GWANGJU */}
암살자 (am hal ja) — assassin <br></br>
부대원 (boo dae won) — military troops <br></br>
시위하다 (si wi ha da) — to protest <br></br>
전남대학교 학생 (jun nam dae hak gyo hak saeng) — students of 전남 university <br></br>
살상 (sal sang) — to kill <br></br>
폭행 (pok haeng) — to beat up <br></br>
강간 (gang gan) — to rape <br></br>
분노 (buhn no) — enragement <br></br>
혐오하다 (hyum oh ha da) — hate or loathe <br></br>




                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;